import * as React from 'react';
import styled from 'styled-components';

import {
	Title,
	Button,
	KeyIcon,
	InputAdornment,
	TextField,
	VisibileIcon,
	HiddenIcon,
	IconButton,
	CircularProgress,
} from '../material-ui';
import { client } from '../apollo-utils';
import { LoginMutation } from '../queries';

const Wrapper = styled.form`
	display: flex;
	flex-flow: column;
	flex: 1;
	padding: 1rem 2rem;
	background: linear-gradient(0deg, #376df0, #19ddff);
	min-height: 100vh;
	justify-content: center;
	align-items: center;
`;

const LoginButton = styled(Button).attrs({
	color: 'secondary',
	variant: 'contained',
})`
	margin-top: 1rem !important;
	color: ${(p) => p.theme.palette.primary.main} !important;
	font-weight: 700 !important;
`;

const PasswordField = styled(TextField)`
	width: 23rem;
	svg,
	input {
		color: white !important;
		height: 2rem;
		margin-left: 0.25rem;
	}
	div::before,
	div:hover::before,
	div::after {
		border-bottom-color: ${(p) => (p.error ? 'black' : 'rgba(255, 255, 255, 0.3)')} !important;
	}
	label {
		color: black !important;
		span {
			display: none;
		}
	}
	input::placeholder {
		color: white;
		opacity: 0.6;
	}
`;

const FieldWrapper = styled.div`
	width: 23rem;
	margin: 2rem 0;
	position: relative;
`;

const LoadingIndicator = styled(CircularProgress).attrs({
	color: 'secondary',
	size: 30,
})`
	position: absolute;
	left: 100%;
	bottom: 0.25rem;
	margin-left: 1rem;
`;

const sendLoginMutation = async (authToken) => {
	if (!authToken) {
		return { errors: [{ message: 'MISSING_AUTH_TOKEN' }] };
	}
	try {
		const result = await client.mutate({
			mutation: LoginMutation,
			variables: { authToken },
			errorPolicy: 'all',
			fetchPolicy: 'no-cache',
		});
		return result;
	} catch (e) {
		if (e.networkError) {
			return { errors: [{ message: 'NETWORK_ERROR' }] };
		} else throw e;
	}
};

export default class LoginScreen extends React.Component {
	state = { showPassword: false, authToken: '', error: null, loading: false };

	componentDidMount() {
		const authToken = window.localStorage.getItem('authToken');
		if (authToken) {
			this.setState({ authToken }, this.handleLogin);
		}
	}

	handleToggleShowPassword = () =>
		this.setState((state) => ({ showPassword: !state.showPassword }));

	handleInputChange = ({ target: { value } }) => this.setState({ authToken: value, error: null });

	handleLogin = async (event) => {
		if (event && event.preventDefault) event.preventDefault();
		const { authToken } = this.state;
		this.setState({ loading: true });
		const { data, errors } = await sendLoginMutation(authToken);
		if (data && data.auth) {
			this.setState({ loading: false });
			const { onLogin } = this.props;
			if (onLogin) onLogin(data.auth);
		} else {
			const errorMessage =
				errors && errors.length > 0 && errors[0].message ? errors[0].message : 'UNKNOWN_ERROR';
			this.setState({ error: errorMessage, loading: false });
		}
	};

	render = () => {
		const { showPassword, authToken, error, loading } = this.state;
		return (
			<Wrapper name="login" id="login" action="" autoComplete="on" onSubmit={this.handleLogin}>
				<Title color="secondary" gutterBottom>
					LOGIN
				</Title>
				<FieldWrapper>
					<PasswordField
						// eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<KeyIcon />
								</InputAdornment>
							),
							endAdornment: (
								<InputAdornment position="end">
									<IconButton onClick={this.handleToggleShowPassword}>
										{showPassword ? <VisibileIcon /> : <HiddenIcon />}
									</IconButton>
								</InputAdornment>
							),
						}}
						required
						name="password"
						id="password"
						autoComplete="on"
						error={Boolean(error)}
						label={
							{
								MISSING_AUTH_TOKEN: 'Kein Kennwort angegeben',
								INVALID_AUTHTOKEN: 'Falsches Kennwort',
								NETWORK_ERROR: 'Keine Netzwerkverbindung',
								UNKNOWN_ERROR: 'Unbekannter Fehler',
							}[error] || ' '
						}
						autoFocus
						placeholder="Gerätkennwort"
						type={showPassword ? 'text' : 'password'}
						onChange={this.handleInputChange}
						value={authToken}
					/>
					{loading ? <LoadingIndicator /> : <span />}
				</FieldWrapper>
				<LoginButton type="submit" disabled={error && error !== 'NETWORK_ERROR'}>
					Einloggen
				</LoginButton>
			</Wrapper>
		);
	};
}



// WEBPACK FOOTER //
// ./src/screens/Login.js